export function DiningOptionDisplayFilter(DINING_OPTION) {
    'ngInject';
    return function(diningOption, current) {
        const PICKUP = 'pickup';
        const DELIVERY = 'delivery';
        if (current) {
            return diningOption === DINING_OPTION.DELIVERY ? DELIVERY : PICKUP;
        } else {
            return diningOption === DINING_OPTION.DELIVERY ? PICKUP : DELIVERY;
        }
    };
}
